<div class="action-configs">
    <h2>Report Settings Editor</h2>
    <p>Region ID: {{ data?.regionId }}</p>
    <select [(ngModel)]="selectedReportType">
        <option *ngFor="let reportType of reportTypes" [value]="reportType">{{ reportType }}</option>
    </select>

    <ng-container *ngIf="selectedReportType === 'actionCodes' && data?.actionCodes">
        <div *ngFor="let cfg of data.actionCodes.actionConfigs; let i = index" class="cfg-box">
            <div class="cfg-header">
                <strong>{{ cfg.label }}</strong>
                <label>
                    Active:
                    <input type="checkbox" [(ngModel)]="cfg.isActive" />
                </label>
            </div>

            <div class="cfg-fields">
                <label>Name: <input type="text" [(ngModel)]="cfg.name" /></label>
                <label>Label: <input type="text" [(ngModel)]="cfg.label" /></label>
                <label>Order: <input type="number" [(ngModel)]="cfg.order" /></label>
            </div>

            <!-- Codes list -->
            <div class="codes">
                <h4>Codes</h4>

                <div *ngFor="let code of cfg.codes; let ci = index" class="code-row">
                    <label>Name: <input type="text" [(ngModel)]="code.name" /></label>
                    <label>Label: <input type="text" [(ngModel)]="code.label" /></label>
                    <label>Order: <input type="number" [(ngModel)]="code.order" /></label>

                    <label>
                        Active:
                        <input type="checkbox" [(ngModel)]="code.isActive" />
                    </label>

                    <label>
                        Merge With:
                        <input type="text" [(ngModel)]="code.mergeWithName" placeholder="optional" />
                    </label>

                    <button class="remove-btn" (click)="removeCode(i, ci)">X</button>
                </div>

                <button class="add-btn" (click)="addCode(i)">+ Add Code</button>
            </div>

        </div>

    </ng-container>

    <ng-container *ngIf="selectedReportType === 'actionTrends'">
        <div *ngFor="let cfg of data.actionTrends.actionConfigs; let i = index" class="cfg-box">
            <div class="cfg-header">
                <strong>{{ cfg.label }}</strong>
                <label>
                    Active:
                    <input type="checkbox" [(ngModel)]="cfg.isActive" />
                </label>
            </div>

            <div class="cfg-fields">
                <label>Name: <input type="text" [(ngModel)]="cfg.name" /></label>
                <label>Label: <input type="text" [(ngModel)]="cfg.label" /></label>
                <label>Order: <input type="number" [(ngModel)]="cfg.order" /></label>
            </div>

            <!-- Codes list -->
            <div class="codes">
                <h4>Codes</h4>

                <div *ngFor="let code of cfg.codes; let ci = index" class="code-row">
                    <label>Name: <input type="text" [(ngModel)]="code.name" /></label>
                    <label>Label: <input type="text" [(ngModel)]="code.label" /></label>
                    <label>Order: <input type="number" [(ngModel)]="code.order" /></label>

                    <label>
                        Active:
                        <input type="checkbox" [(ngModel)]="code.isActive" />
                    </label>

                    <label>
                        Merge With:
                        <input type="text" [(ngModel)]="code.mergeWithName" placeholder="optional" />
                    </label>

                    <button class="remove-btn" (click)="removeCode(i, ci)">X</button>
                </div>

                <button class="add-btn" (click)="addCode(i)">+ Add Code</button>
            </div>

        </div>

    </ng-container>

    <ng-container *ngIf="selectedReportType === 'hospitalTracker'">
        <!-- HOSPITAL TRACKER EDITOR -->
        <div class="hospital-tracker cfg-box">
            <div class="cfg-header">
                <strong>Hospital Tracker</strong>
            </div>

            <!-- tableCleaningCode -->
            <div class="hospital-section">
                <h4>Table Cleaning Codes</h4>
                <div class="code-list">
                    <div class="code-row simple-row"
                        *ngFor="let code of data.hospitalTracker.tableCleaningCode; let i = index; trackBy: trackByIndex">
                        <label>
                            Code:
                            <input type="text" [(ngModel)]="data.hospitalTracker.tableCleaningCode[i]" />
                        </label>
                        <button class="remove-btn" (click)="removeHospitalCode('tableCleaningCode', i)">X</button>
                    </div>
                    <button class="add-btn" (click)="addHospitalCode('tableCleaningCode')">
                        + Add Code
                    </button>
                </div>
            </div>

            <!-- priorCodeToCleaning -->
            <div class="hospital-section">
                <h4>Prior Code To Cleaning</h4>
                <div class="code-list">
                    <div class="code-row simple-row"
                        *ngFor="let code of data.hospitalTracker.priorCodeToCleaning; let i = index; trackBy: trackByIndex">
                        <label>
                            Code:
                            <input type="text" [(ngModel)]="data.hospitalTracker.priorCodeToCleaning[i]" />
                        </label>
                        <button class="remove-btn" (click)="removeHospitalCode('priorCodeToCleaning', i)">X</button>
                    </div>
                    <button class="add-btn" (click)="addHospitalCode('priorCodeToCleaning')">
                        + Add Code
                    </button>
                </div>
            </div>

            <!-- returningToSnfCodes -->
            <div class="hospital-section">
                <h4>Returning To SNF Codes</h4>
                <div class="code-list">
                    <div class="code-row simple-row"
                        *ngFor="let code of data.hospitalTracker.returningToSnfCodes; let i = index; trackBy: trackByIndex">
                        <label>
                            Code:
                            <input type="text" [(ngModel)]="data.hospitalTracker.returningToSnfCodes[i]" />
                        </label>
                        <button class="remove-btn" (click)="removeHospitalCode('returningToSnfCodes', i)">X</button>
                    </div>
                    <button class="add-btn" (click)="addHospitalCode('returningToSnfCodes')">
                        + Add Code
                    </button>
                </div>
            </div>

            <!-- deathABR -->
            <div class="hospital-section">
                <h4>Death ABR Codes</h4>
                <div class="code-list">
                    <div class="code-row simple-row"
                        *ngFor="let code of data.hospitalTracker.deathABR; let i = index; trackBy: trackByIndex ">
                        <label>
                            Code:
                            <input type="text" [(ngModel)]="data.hospitalTracker.deathABR[i]" />
                        </label>
                        <button class="remove-btn" (click)="removeHospitalCode('deathABR', i)">X</button>
                    </div>
                    <button class="add-btn" (click)="addHospitalCode('deathABR')">
                        + Add Code
                    </button>
                </div>
            </div>
        </div>

    </ng-container>


    <button class="save-btn" (click)="save()">💾 Save Changes</button>
</div>